export enum SubmittedAsType {
    INSUREE = 'INSUREE',
    LEGAL_REPRESENTATIVE = 'LEGAL_REPRESENTATIVE',
}
